import React, { useState } from "react";
import classNames from "classnames/bind";
import Filter from "./Filter/Filter";
import Table from "./Table/Table";
import styles from "./Role.module.css";

const cx = classNames.bind(styles);
const Role = () => {
  const [status, setStatus] = useState(200);
  const [nameRole, setNameRole] = useState('');
  return (
    <>
      <div className={cx("header")}>
        <h1 className={cx("title")}>Danh sách quyền</h1>
      </div>
      <div className={cx("content")}>
        <Filter status={status} onChangeName={(data) => setNameRole(data)}/>
        <Table onGetStatus={data => setStatus(data)} nameRole={nameRole}/>
      </div>
    </>
  );
};

export default Role;
